import { render } from "./PromotionTools.vue?vue&type=template&id=66eabfc3"
import script from "./PromotionTools.vue?vue&type=script&lang=js"
export * from "./PromotionTools.vue?vue&type=script&lang=js"

import "./PromotionTools.vue?vue&type=style&index=0&id=66eabfc3&lang=css"

import exportComponent from "C:\\Users\\david\\Desktop\\Netloud\\whiteLabel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__